import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  completeLaunchDailyReview,
  fetchDailyMonitor,
  resolveLaunchAlert,
  saveLaunchDailyNote,
} from "../../../services/automapBuyerLaunchApi";
import { LaunchShell } from "./AdminLaunchShared";

export default function AdminLaunchDailyMonitorPage() {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [note, setNote] = useState({ summary: "", wins: "", issues: "", nextActions: "" });

  const load = () => {
    setLoading(true);
    fetchDailyMonitor()
      .then((data) => {
        setPayload(data);
        if (data.note) setNote(data.note);
      })
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const saveNote = async () => {
    await saveLaunchDailyNote({ ...note, date: payload?.date });
    load();
  };

  const markReview = async () => {
    await completeLaunchDailyReview(payload?.date);
    load();
  };

  return (
    <LaunchShell
      active="daily"
      title="Daily launch monitor"
      description="Revisión operativa diaria del lanzamiento."
      viewEvent="launch_daily_monitor_viewed"
    >
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {!loading && payload ? (
        <>
          <p>Fecha: {payload.date} {payload.dailyReviewComplete ? "· Revisión completada ✓" : ""}</p>
          <div className="dashboard-summary-grid">
            {[
              { label: "Sesiones hoy", value: payload.traffic?.sessions },
              { label: "Leads hoy", value: payload.traffic?.leads },
              { label: "WhatsApp hoy", value: payload.traffic?.whatsappClicks },
            ].map((item) => (
              <div key={item.label} className="dashboard-summary-card">
                <span className="dashboard-summary-label">{item.label}</span>
                <strong>{item.value ?? 0}</strong>
              </div>
            ))}
          </div>
          <section className="dealer-state-box">
            <h3>Dealers con leads nuevos</h3>
            {!payload.dealersWithNewLeads?.length ? (
              <p className="muted">Ninguno hoy.</p>
            ) : (
              <ul>
                {payload.dealersWithNewLeads.map((d) => (
                  <li key={d.dealerId}>
                    <Link to={`/admin/dealers/${d.dealerId}`}>{d.dealerName}</Link> — {d.count} leads
                  </li>
                ))}
              </ul>
            )}
          </section>
          <section className="dealer-state-box">
            <h3>Sin respuesta (&gt;2h)</h3>
            {!payload.unresponsiveDealers?.length ? (
              <p className="muted">Ninguno.</p>
            ) : (
              <ul>
                {payload.unresponsiveDealers.map((d) => (
                  <li key={d.leadId}>
                    {d.dealerName} — {d.hoursSinceLead}h ·{" "}
                    <Link to={`/admin/leads/${d.leadId}`}>Ver lead</Link>
                  </li>
                ))}
              </ul>
            )}
          </section>
          {payload.alerts?.length ? (
            <section className="dealer-state-box">
              <h3>Alertas</h3>
              {payload.alerts.map((a) => (
                <div key={a.id} style={{ marginBottom: "0.5rem" }}>
                  [{a.severity}] {a.title} — {a.description}{" "}
                  <button type="button" className="admin-link" onClick={() => resolveLaunchAlert(a.id).then(load)}>
                    Resolver
                  </button>
                </div>
              ))}
            </section>
          ) : null}
          <section className="dealer-state-box">
            <h3>Nota del día</h3>
            <textarea placeholder="Resumen" value={note.summary} onChange={(e) => setNote({ ...note, summary: e.target.value })} rows={2} style={{ width: "100%" }} />
            <textarea placeholder="Wins" value={note.wins} onChange={(e) => setNote({ ...note, wins: e.target.value })} rows={2} style={{ width: "100%" }} />
            <textarea placeholder="Issues" value={note.issues} onChange={(e) => setNote({ ...note, issues: e.target.value })} rows={2} style={{ width: "100%" }} />
            <textarea placeholder="Próximas acciones" value={note.nextActions} onChange={(e) => setNote({ ...note, nextActions: e.target.value })} rows={2} style={{ width: "100%" }} />
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
              <button type="button" className="dealer-portal-btn" onClick={saveNote}>
                Guardar nota
              </button>
              <button type="button" className="dealer-portal-btn" onClick={markReview}>
                Marcar revisión completa
              </button>
            </div>
          </section>
        </>
      ) : null}
    </LaunchShell>
  );
}
